import { useEffect } from "react";
import { MAX_DESCRIPTION_LENGTH, truncateString } from "./helpers/helpers";

/**
 * Custom hook to set the meta description of the document.
 * @param description - The description to set for the meta tag.
 */
export const useMetaDescription = (description?: string | null) => {
  useEffect(() => {
    const metaDescriptionTag = document.querySelector(
      'meta[name="description"]'
    );
    const prevDescription = metaDescriptionTag?.getAttribute("content") || "";

    if (description) {
      const limitedLengthDescription = truncateString(
        description,
        MAX_DESCRIPTION_LENGTH
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", limitedLengthDescription);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.setAttribute("name", "description");
        newMetaTag.setAttribute("content", limitedLengthDescription);
        document.head.appendChild(newMetaTag);
      }
    }

    return () => {
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", prevDescription);
      }
    };
  }, [description]);
};
